import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";

class PreviousObstetricHistoryPregnancy extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    const TableData = {};
    this.state = {
      Year: "",
      EvolutionPreviousPregnancy: "",
      ModeDeliveryMode: "",
      InfantWeight: "",
      Sex: "",
      InfantState: "",
      visitid: "",
      rowNumber: "2",
      patientName: localStorage.getItem("currentVisitName"),
      DataLoaded: false,
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    var rowNumber = this.state["rowNumber"];

    var tableRow =
      '<tr><td><input className="form-control" name="Year" onChange={this.handleChange} value={Year}  type="text" required/> </td><td><textarea className="form-control" name="EvolutionPreviousPregnancy" onChange={this.handleChange} value={EvolutionPreviousPregnancy}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td><td><textarea className="form-control" name="Sex" onChange={this.handleChange} value={Sex}></textarea></td> <td><textarea className="form-control" name="ModeDeliveryMode" onChange={this.handleChange} value={ModeDeliveryMode}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td></tr>';
    $(".add-row").on("click", function () {
      $(".tableBody").append(tableRow);
    });
    this.setState({ rowNumber: parseInt(rowNumber) + 1 });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
    };

    console.log(headers);

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
      loading: true
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var year = this.state.tablevaluesglobal[i]["Year"];
      var dict = {
        Year: year,
        EvolutionPreviousPregnancy:
          this.state.tablevaluesglobal[i]["EvolutionPreviousPregnancy"],
        ModeDeliveryMode: this.state.tablevaluesglobal[i]["ModeDeliveryMode"],
        InfantWeight: this.state.tablevaluesglobal[i]["InfantWeight"],
        Sex: this.state.tablevaluesglobal[i]["Sex"],
        InfantState: this.state.tablevaluesglobal[i]["InfantState"],
      };

      axios
        .post(
          this.api_url+""+localStorage.getItem('currentModule')+"/pregnancyhistorytable/main",
          dict,
          { headers: headers }
        )
        .then((response) => {
          this.setState({
            loading:false
          })
          console.log(dict)
          // /triage/antenatal/history
    
           
                
                let table = dict;
                console.log(table.length);
                // let object = {};
                // for (let i = 0; i < table.length; i++) {
                //   delete table[i]._id;
                //   delete table[i].timeOfRegistration;
                //   table[i].clickEvent = () => this.handleRowClick(table[i]);
                // }
                // // table = JSON.stringify(table);
                // this.TableData = table;
                // console.log(this.TableData);
                // this.setState({
                //   DataLoaded: true,
                // });
             

            if (response.data.status) {
              $(".alert-success").show();
              setTimeout(function () {
                // alert('sdsd')
                $(".HistoryModal").show();
              }, 1500);
            }
         
        })
        .catch((error) => {
          $('#SubmitError').fadeIn()
          console.log(error);
        });
    }
  };

  proceedEvent(event) {
    window.location.href = "/antenatal/history";
  }

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();

    $(".proceed").click();
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });
      trimobj.Year = data[i][0];
      trimobj.EvolutionPreviousPregnancy = data[i][1];
      trimobj.ModeDeliveryMode = data[i][2];
      trimobj.InfantWeight = data[i][3];
      trimobj.Sex = data[i][4];
      trimobj.InfantState = data[i][5];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", ""]];

    const columns = [
      "Year",
      "Evolution of Previous Pregnancy",
      "Mode Of Delivery",
      "Weight of Infant",
      "Sex",
      "State of Infant",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const { patientName, loading } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Year",
          field: "Year",
          sort: "asc",
          width: 50,
        },
        {
          label: "Evolution of Previous Pregnancy",
          field: "EvolutionPreviousPregnancy",
          sort: "asc",
          width: 50,
        },
        {
          label: "Mode Of Delivery",
          field: "ModeDeliveryMode",
          sort: "asc",
          width: 50,
        },
        {
          label: "Weight of Infant",
          field: "InfantWeight",
          sort: "asc",
          width: 50,
        },
        {
          label: "Sex",
          field: "Sex",
          sort: "asc",
          width: 50,
        },
        {
          label: "State of Infant",
          field: "InfantState",
          sort: "asc",
          width: 50,
        },
        // {
        //     label: "Patient ID",
        //     field: "patientid",
        //     sort: "asc",
        //     width: 50
        // },
      ],
      rows: this.TableData,
    };

    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Previous Pregancy Obstetrics History
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Previous Obstetrics History Saved
                Successfully.
              </div>

              <div
                className="modal HistoryModal"
                style={autoscroll}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        {patientName}`s PreviousObstetric History Pregnancy
                        Modal
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                      <br />
                      <a
                        className="btn btn-danger proceed"
                        onClick={this.proceedEvent}
                        style={width100}
                      >
                        Proceed to Next
                      </a>
                      <Preview id={"jsx-template"}>
                        <b>NAME: </b>
                        {patientName}

                        <MDBDataTable striped bordered data={tabledata} />
                      </Preview>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PreviousObstetricHistoryPregnancy;
